/**
 * Ürün sayfasındaki sabit satın alma çubuğu.
 *
 * Üç iş yapar:
 *  1. Asıl "Sepete ekle" düğmesi ekrandan çıkınca çubuğu gösterir, geri gelince gizler.
 *     Ölçüm IntersectionObserver ile yapılır, scroll dinleyicisiyle değil.
 *  2. Çubuktaki düğme kendi isteğini atmaz; asıl formun düğmesine tıklar. Böylece teslimat
 *     günü ve hediye mesajı penceresi tek yerden yönetilir.
 *  3. Varyant değişince fiyatı asıl fiyat alanından kopyalar ve kesim saatine kalan süreyi
 *     dakika başı yeniler.
 */
if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-buy-submit]');
        this.priceEl = this.querySelector('[data-sticky-buy-price]');
        this.cutoffEl = this.querySelector('[data-sticky-buy-cutoff]');
        // Metin ayri span'de; rozetin icindeki ikon `textContent` ile silinmesin.
        this.cutoffTextEl = this.querySelector('[data-sticky-buy-cutoff-text]') || this.cutoffEl;
        this.rowEl = this.querySelector('[data-sticky-buy-row]');

        this.form = document.querySelector(`#product-form-${this.sectionId}`);
        this.realButton = this.form?.querySelector('[name="add"]');
        if (!this.button || !this.realButton) return;

        this.button.addEventListener('click', () => this.realButton.click());

        this.gozlemciKur();
        this.fiyatiEsitle();
        this.kesimSaatiYaz();
        // Süre dakika cinsinden yazıldığı için saniye başı yenilemeye gerek yok;
        // on saniye, dakika değişimini gözle görülür gecikme olmadan yakalar.
        this.zamanlayici = setInterval(() => this.kesimSaatiYaz(), 10000);

        // Varyant değişince Dawn fiyat alanını yeniden basar.
        this.fiyatGozlemcisi = new MutationObserver(() => this.fiyatiEsitle());
        const fiyatKutusu = document.getElementById(`price-${this.sectionId}`);
        if (fiyatKutusu) this.fiyatGozlemcisi.observe(fiyatKutusu, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        clearInterval(this.zamanlayici);
        this.gozlemci?.disconnect();
        this.fiyatGozlemcisi?.disconnect();
      }

      /**
       * Sayaç şeridi sayfa boyunca görünür; satın alma satırı yalnız asıl fiyat ve
       * düğme ekrandan çıkınca açılır. Böylece fiyat zaten ekrandayken alttan ikinci
       * bir fiyat çıkmıyor.
       */
      gozlemciKur() {
        this.gozlemci = new IntersectionObserver(
          ([giris]) => {
            if (this.rowEl) this.rowEl.hidden = giris.isIntersecting;
            this.classList.toggle('is-compact', giris.isIntersecting);
          },
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.gozlemci.observe(this.realButton);
        // Çubuğun kendisi hep açık: sayaç her zaman görünmeli.
        this.hidden = false;
      }

      fiyatiEsitle() {
        const kaynak = document.querySelector(`#price-${this.sectionId} .price-item--last`);
        const metin = kaynak?.textContent.trim();
        if (metin) this.priceEl.textContent = metin;
      }

      kesimSaatiYaz() {
        const kaynak = document.querySelector('[data-cart-countdown]');
        const cutoff = Number(kaynak?.dataset.cutoffHour || this.dataset.cutoffHour || 16);
        const p = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Istanbul',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(new Date())
          .reduce((a, x) => {
            a[x.type] = x.value;
            return a;
          }, {});

        const kalanSn =
          (cutoff - Number(p.hour)) * 3600 - Number(p.minute) * 60 - Number(p.second);

        if (kalanSn <= 0) {
          this.cutoffTextEl.textContent = this.dataset.closedText || '';
          this.cutoffEl.hidden = !this.dataset.closedText;
          return;
        }

        /* Süre dakika cinsinden yazılıyor: "40 dakika", "1 saat 20 dakika". Saniyeli
           sayaç (40:37) rozette saat okumaktan çok geri sayım gibi duruyordu. Başlamış
           dakika tam sayılıyor, yoksa 39:34 kala "39 dakika" yazıp bir dakika eksik
           görünürdü. Sepetteki teslimat sayacı da aynı dili kullanıyor. */
        const kalanDk = Math.ceil(kalanSn / 60);
        const saat = Math.floor(kalanDk / 60);
        const dakika = kalanDk % 60;

        let sure;
        if (saat > 0 && dakika > 0) sure = `${saat} saat ${dakika} dakika`;
        else if (saat > 0) sure = `${saat} saat`;
        else sure = `${dakika} dakika`;

        this.cutoffTextEl.textContent = (this.dataset.openText || '').replace('{{ kalan }}', sure);
        this.cutoffEl.hidden = !this.dataset.openText;
      }
    }
  );
}
